<template>
  <div class="footer">
    <div class="container">
      <!-- Frame 48097822 -->
      <div class="footer-logo-mobile">
        <BTrackingClickEvent 
          event="comics_event_comic_music_global_item_click"
          eventId="8503"
          :pageInfo="{tab:''}"
          :clickInfo="{sec:'footer',name:'comics logo'}"
          >
          <img
            class="logo-img"
            :id="footerComicsId"
            @click="link(comics_url, true)"
            src="/images/20231109/footer/footer_漫畫星.svg"
          />
        </BTrackingClickEvent>
        <BTrackingClickEvent 
          event="comics_event_comic_music_global_item_click"
          eventId="8503"
          :pageInfo="{tab:''}"
          :clickInfo="{sec:'footer',name:'novels logo'}"
          >
          <img
            class="logo-img"
            :id="footerNovelsId"
            @click="link(novels_url, true)"
            src="/images/20231109/footer/footer_文學星.svg"
          />
        </BTrackingClickEvent>
      </div>
      <div class="footer-logo-desktop">
        <BTrackingClickEvent 
          event="comics_event_comic_music_global_item_click"
          eventId="8503"
          :pageInfo="{tab:''}"
          :clickInfo="{sec:'footer',name:'comics logo'}"
          >
          <img
            class="logo-img-d"
            :id="footerComicsId"
            @click="link(comics_url, true)"
            src="/images/20231109/footer/footer_漫畫星_d.svg"
          />
        </BTrackingClickEvent>
        <BTrackingClickEvent 
          event="comics_event_comic_music_global_item_click"
          eventId="8503"
          :pageInfo="{tab:''}"
          :clickInfo="{sec:'footer',name:'novels logo'}"
          >
          <img
            class="logo-img-d"
            :id="footerNovelsId"
            @click="link(novels_url, true)"
            src="/images/20231109/footer/footer_文學星_d.svg"
          />
        </BTrackingClickEvent>
      </div>
      <div class="social-link">
        <div class="g-link-mobile">
          <div @click="link('https://www.instagram.com/comic.funhere/', true)">
            <BTrackingClickEvent 
              event="comics_event_comic_music_global_item_click"
              eventId="8503"
              :pageInfo="{tab:''}"
              :clickInfo="{sec:'footer',name:'toinstagram'}"
            >
            <img
              :id="footerNomics_IGId"
              class="g-link-mobile-img"
              src="/images/20231109/footer/m-ig-link.svg"
            />
            </BTrackingClickEvent>
          </div>
          <div @click="link('https://www.facebook.com/funnovel/', true)">
            <BTrackingClickEvent 
              event="comics_event_comic_music_global_item_click"
              eventId="8503"
              :pageInfo="{tab:''}"
              :clickInfo="{sec:'footer',name:'tofacebook'}"
            >
            <img
              :id="footerNovels_FBId"
              class="g-link-mobile-img"
              src="/images/20231109/footer/m-facebook-link.svg"
            />
            </BTrackingClickEvent>
          </div>
        </div>
      </div>
    </div>
    <div class="g-link-desktop">
      <div
        class="g-link"
        @click="link('https://www.instagram.com/comic.funhere/', true)"
      >
      <BTrackingClickEvent 
              event="comics_event_comic_music_global_item_click"
              eventId="8503"
              :pageInfo="{tab:''}"
              :clickInfo="{sec:'footer',name:'toinstagram'}"
            >
        <img
          :id="footerNomics_IGId_qr"
          src="/images/20231109/footer/漫畫星官方IG.svg"
        />
        </BTrackingClickEvent>
      </div>
      <div
        class="g-link"
        @click="link('https://www.facebook.com/funnovel/', true)"
      >
      <BTrackingClickEvent 
              event="comics_event_comic_music_global_item_click"
              eventId="8503"
              :pageInfo="{tab:''}"
              :clickInfo="{sec:'footer',name:'tofacebook'}"
            >
        <img
          :id="footerNovels_FBId_qr"
          src="/images/20231109/footer/文學星FB粉絲團.svg"
        />
        </BTrackingClickEvent>
      </div>
    </div>
    <div class="copy-right">© 2023 Gamania Group</div>
  </div>
</template>

<script lang="ts">
import * as common from "@/api/common";
import { openLink } from "@/lib/Utils";
import BTrackingClickEvent from '@/components/BTracking/BTrackingClickEvent.vue';
export default {
  name: "Footer",
  components:{
    BTrackingClickEvent
  },
  props: {
    msg: String,
    prefix: String,
  },
  data() {
    return {
      footerComicsId: this.prefix + "footer_comics",
      footerNovelsId: this.prefix + "footer_novels",
      footerNomics_IGId_qr: this.prefix + "footer_comics_IG_qrcode",
      footerNovels_FBId_qr: this.prefix + "footer_novels_FB_qrcode",
      footerNomics_IGId: this.prefix + "footer_comics_IG",
      footerNovels_FBId: this.prefix + "footer_novels_FB",
      // comics_url: import.meta.env.VITE_COMICS_URL, // 漫畫星轉址
      comics_url: "https://comics.beanfun.com/", // 漫畫星轉址
      // novels_url: import.meta.env.VITE_NOVELS_URL, // 文學星轉址
      novels_url: "https://novels.beanfun.com/", // 文學星轉址
    };
  },
  methods: {
    // 開啟外部連結
    link(url: string, open: boolean) {
      openLink({ url: url, open: open });
    },
  },
};
</script>

<style scoped>
/* ------ 大網 ------ */
.footer {
  width: 100vw;
  text-align: left;
  background-color: black;
  position: relative;
  display: block;
  border-bottom: none;
  border-left: none;
  border-right: none;
  height: 268px;
}
.footer .copy-right {
  font-family: Noto Sans TC;
  width: 100%;
  position: absolute;
  color: white;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 23.17px;
  bottom: 23.5px;
}
.footer .container {
  display: flex;
  flex-direction: column;
  align-items: center; /* 置中設定 */
  justify-content: center;
}
.footer .container .footer-logo-mobile {
  display: none;
}
.footer .container .footer-logo-desktop {
  display: inline-block;
  margin-top: 67px;
}
.footer-logo-mobile .logo-img {
  height: 36.23px;
  cursor: pointer;
}
.footer-logo-desktop .logo-img-d {
  height: 38px;
  margin: 17.5px 26px;
  cursor: pointer;
}
.social-link .g-link-mobile {
  display: none;
}
.footer .g-link-desktop {
  position: absolute;
  right: 100px;
  top: 42px;
  gap: 100px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.footer .g-link-desktop .g-link {
  cursor: pointer;
}
/* ------- 小網 ------ */
@media screen and (max-width: 1031px) {
  .footer {
    height: 202px;
  }
  .footer .copy-right {
    font-size: 12px;
    font-weight: 400;
    line-height: 28px;
    bottom: 3.5px;
  }
  .footer .container .footer-logo-mobile {
    display: inline-block;
    margin-top: 20px;
  }
  .footer .container .footer-logo-desktop {
    display: none;
  }
  .footer-logo-mobile .logo-img {
    height: 36px;
    margin: 0 4px;
  }
  .footer-logo-desktop .logo-img-d {
    height: 18px !important;
  }
  .social-link .g-link-mobile {
    display: block;
  }
  .social-link .g-link-mobile .g-link-mobile-img {
    margin-top: 16px;
    height: 21px;
  }
  .footer .g-link-desktop {
    display: none;
  }
}
</style>
